import { useChangeFilterTrack } from "@/_old/features/analytics";
import { Group } from "@/company/groups/types";
import { GroupInput } from "@/core/components/layout/group-input";
import { Label } from "@/core/components/ui/label";
import { useDashboardFilters } from "@/dashboard/store/useDashboardFilters";
import { isDsFilterLocation } from "../ds-filter-field";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

interface GroupFilterProps {
  location: string;
  onSubmit?: boolean;
  onChange?: (value: Group | null) => void;
  asCheckbox?: boolean;
}

export function GroupFilter({
  location,
  onSubmit,
  onChange,
  asCheckbox = false,
}: GroupFilterProps) {
  const [translate] = useTranslation(["core"]);
  const { onChangeFilter } = useChangeFilterTrack();
  const { filters, setFilters } = useDashboardFilters();

  const value = useMemo(() => {
    return filters.group_id || null;
  }, [filters.group_id]);

  const handleChange = useCallback(
    (value: Group | null) => {
      //   onChangeFilter("FILTER_MEMBERS", eventCategory);

      const group_id: number = value?.id || 0;

      if (onSubmit) {
        onChange?.(value as Group);
      } else {
        setFilters({ group_id });
      }
    },
    [onChange, onSubmit, setFilters],
  );

  if (isDsFilterLocation(location)) {
    // Busca + paginação de centros de custo não cabem no InputSelect do
    // Workbase DS: o GroupInput usa o DsSelectMenu (visual do InputSelect,
    // seleção única com Radio do DS).
    return (
      <GroupInput
        appearance="ds"
        label={translate("groups-filter-label") as string}
        inputId={`${location}-group-filter`}
        defaultValue={value as Group | null}
        hasEmptyValue={true}
        placeholder={translate("groups-filter-placeholder") as string}
        onChange={handleChange}
      />
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={`${location}-group-filter`}>
        {translate("groups-filter-label") as string}
      </Label>

      <GroupInput
        inputId={`${location}-group-filter`}
        defaultValue={value as Group | null}
        hasEmptyValue={true}
        placeholder={translate("groups-filter-placeholder") as string}
        onChange={handleChange}
        asCheckbox={asCheckbox}
      />
    </div>
  );
}
